import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "../../../component/library/pagination";
import Loader from "../../../component/common/loader";
import "./style.css";

const PAGE_SIZE = 20;

const MembershipManagement = () => {
  const [users, setUsers] = useState([]);
  const [membershipDetails, setMembeshipDetails] = useState([]);
  const [editMode, setEditMode] = useState(null);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("LOGIN_HEADER");
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_APIUrl}admin/viewMembership`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit: PAGE_SIZE },
      })
      .then((response) => {
        const payload = response.data?.data ?? response.data;
        const userList = Array.isArray(payload) ? payload : payload?.data ?? [];
        const pagination = Array.isArray(payload) ? null : payload?.pagination;
        setUsers(userList);
        if (pagination) {
          setPages({
            currentPage: pagination.currentPage ?? page,
            totalPages: pagination.totalPages ?? 1,
            totalItems: pagination.totalItems ?? 0,
          });
        } else {
          setPages({
            currentPage: 1,
            totalPages: 1,
            totalItems: userList.length,
          });
        }
      })
      .catch((error) => console.error("Error fetching user data:", error))
      .finally(() => setLoading(false));
  }, [page]);

  useEffect(() => {
    // Fetch membership details from the server
    axios
      .get(`${process.env.REACT_APP_APIUrl}user/subscription?status=active`)
      .then((response) => {
        console.log(response.data.data);
        setMembeshipDetails(response.data.data);
      })
      .catch((error) =>
        console.error("Error fetching membership details:", error)
      );
  }, []);

  const getPlanId = (m) => m?._id ?? m?.id;

  const handlePlanChange = (userId, newPlanId) => {
    const membershipData = membershipDetails.find(
      (plan) => getPlanId(plan) === newPlanId
    );
    if (!membershipData) return;
    const updatedUsers = users.map((user) =>
      user._id === userId
        ? {
            ...user,
            activeMembership: {
              ...user.activeMembership,
              subscriptionId: getPlanId(membershipData),
              subscriptionName: membershipData.name,
            },
          }
        : user
    );
    setUsers(updatedUsers);
  };

  const handleDateChange = (userId, startDate, endDate) => {
    const updatedUsers = users.map((user) =>
      user._id === userId
        ? {
            ...user,
            activeMembership: {
              ...user.activeMembership,
              startDate,
              endDate,
            },
          }
        : user
    );
    setUsers(updatedUsers);
  };

  const handleSave = (userId) => {
    const user = users.find((user) => user._id === userId);
    const token = localStorage.getItem("LOGIN_HEADER");
    axios
      .put(`${process.env.REACT_APP_APIUrl}admin/updateMembership`, user, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setEditMode(null);
        // Optional: fetch updated user data from the server to ensure consistency
      })
      .catch((error) => {
        console.error("Error updating user data:", error);
      });
  };

  const handleEdit = (userId) => {
    setEditMode(userId);
  };

  return (
    <div className="mm-container">
      <div className="mm-card">
        <div className="mm-table-wrap" style={{ position: "relative", minHeight: 120 }}>
          <Loader value={loading} variant="overlay" text="Loading memberships..." />
          <table className="mm-table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Plan</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td className="mm-cell-name">{`${user.firstName || ''} ${user.lastName || ''}`.trim() || '-'}</td>
                  <td>{user.email || '-'}</td>
                  <td>
                    {editMode === user._id ? (
                      <select
                        className="mm-select"
                        value={getPlanId(user.activeMembership?.subscriptionId) || user.activeMembership?.subscriptionId}
                        onChange={(e) => handlePlanChange(user._id, e.target.value)}
                      >
                        {membershipDetails.map((membership) => (
                          <option key={getPlanId(membership)} value={getPlanId(membership)}>
                            {membership.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      user.activeMembership?.subscriptionName || '-'
                    )}
                  </td>
                  <td>
                    {editMode === user._id ? (
                      <input
                        type="date"
                        className="mm-input"
                        value={user.activeMembership?.startDate?.substr?.(0, 10) ?? user.activeMembership?.startDate ?? ''}
                        onChange={(e) =>
                          handleDateChange(
                            user._id,
                            e.target.value,
                            user.activeMembership?.endDate?.substr?.(0, 10) ?? user.activeMembership?.endDate ?? ''
                          )
                        }
                      />
                    ) : (
                      user.activeMembership?.startDate?.substr?.(0, 10) ?? user.activeMembership?.startDate ?? '-'
                    )}
                  </td>
                  <td>
                    {editMode === user._id ? (
                      <input
                        type="date"
                        className="mm-input"
                        value={user.activeMembership?.endDate?.substr?.(0, 10) ?? user.activeMembership?.endDate ?? ''}
                        onChange={(e) =>
                          handleDateChange(
                            user._id,
                            user.activeMembership?.startDate?.substr?.(0, 10) ?? user.activeMembership?.startDate ?? '',
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      user.activeMembership?.endDate?.substr?.(0, 10) ?? user.activeMembership?.endDate ?? '-'
                    )}
                  </td>
                  <td>
                    {editMode === user._id ? (
                      <button
                        type="button"
                        className="mm-btn mm-btn-save"
                        onClick={() => handleSave(user._id)}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="mm-btn mm-btn-edit"
                        onClick={() => handleEdit(user._id)}
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!loading && pages.totalItems > 0 && (
          <div className="mm-pagination-wrap">
            <span className="mm-pagination-info">
              Showing {(page - 1) * PAGE_SIZE + 1} to {Math.min(page * PAGE_SIZE, pages.totalItems)} of {pages.totalItems} members
            </span>
            {pages.totalPages > 1 && <Pagination pages={pages} page={page} setPage={setPage} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipManagement;
